import React, { useEffect, useRef } from 'react';
import { FiX } from 'react-icons/fi';

const VideoModal = ({ videoUrl, onClose }) => {
    const modalRef = useRef(null);
    const videoRef = useRef(null);

    useEffect(() => {
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';

        // Handle escape key press
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);

        return () => {
            document.body.style.overflow = 'unset';
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    const handleBackdropClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
            onClick={handleBackdropClick}
        >
            <div
                ref={modalRef}
                className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 z-10 p-2 rounded-full bg-black/50 hover:bg-black/70 text-white transition-colors"
                >
                    <FiX className="w-6 h-6" />
                </button>

                {/* Video player */}
                <video
                    ref={videoRef}
                    src={videoUrl}
                    controls
                    autoPlay
                    controlsList="nodownload noremoteplayback"
                    className="w-full h-full max-h-[80vh] object-contain"
                    playsInline
                />
            </div>
        </div>
    );
};

export default VideoModal;